<script>
import { getOpenGraphData } from '../api/open-graph';

export default {
  name: 'OpenGraphPreview',
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
  },
  components: {
    getAllUrls: require('../mixins/utils.js').default,
    CpShowImageInCard: require('./ShowImageInCard').default,
  },
  props: {
    content: { type: String, required: true },
  },
  data() {
    return {
      ogDataList: [],
      videoSource: ['instagram.com', 'facebook.com', 'youtube.com', 'youtu.be', 'tiktok.com', 'vimeo.com'],
    };
  },
  async mounted() {
    await this.loadOGData(this.content);
  },
  watch: {
    async content(newContent) {
      await this.loadOGData(newContent);
    },
  },
  methods: {
    async loadOGData(content) {
      const urls = this.getAllUrls(content);
      if (urls && urls.length) {
        try {
          const ogResults = await Promise.all(
            urls.map(async url => {
              try {
                const response = await getOpenGraphData({ url });
                return {
                  url,
                  ogData: response,
                };
              } catch (err) {
                console.warn('OG error for', url, err);
                return null;
              }
            }),
          );

          this.ogDataList = ogResults.filter(item => item && Object.keys(item.ogData).length);
        } catch (error) {
          console.error('OpenGraph Error:', error);
        }
      } else {
        this.ogDataList = [];
      }
    },
  },
};
</script>

<template>
  <div v-if="ogDataList.length" class="og">
    <a
      v-for="(item, index) in ogDataList"
      v-if="!videoSource.some(el => item.url.includes(el))"
      :key="index"
      :href="item.url"
      target="_blank"
      :class="{ 'og-container': true, 'og-container-multiple': ogDataList.length > 1 }"
    >
      <div :class="{ 'og-image': true, 'og-image-multiple': ogDataList.length > 1 }">
        <CpShowImageInCard :image="item.ogData.image ?? '/assets/img/imageNotFound.png'" altMessage="Open Graph image" fullWidth />
      </div>
      <div class="og-text">
        <div>
          <h3 :class="{ subhedline1: ogDataList.length === 1, caption1: ogDataList.length > 1, 'neutral5-color': true }" v-margin="0">
            {{ item.ogData.title || 'Title not available' }}
          </h3>
          <p :class="{ body1: ogDataList.length === 1, caption2: ogDataList.length > 1, 'neutral4-color': true }" v-margin="0">
            {{ item.ogData.description || 'Description not available' }}
          </p>
        </div>
        <p :class="{ body1: ogDataList.length === 1, caption2: ogDataList.length > 1, 'neutral4-color': true }" v-margin="0">{{ item.url }}</p>
      </div>
    </a>
  </div>
</template>

<style scoped>
.og {
  display: flex;
  overflow-x: auto;
  gap: 16px;
  padding-bottom: 10px;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.og-container,
.og-container-multiple {
  display: flex;
  text-decoration: none;
  color: inherit;
  border: 1px solid var(--neutral3);
  border-radius: 4px;
  overflow: hidden;
}

.og-container-multiple {
  min-width: 45%;
  max-height: 80px;
  align-items: center;
}

.og-image {
  display: flex;
  max-width: 20%;
}

.og-image-multiple {
  max-width: 10%;
}

.og-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 80%;
  max-width: 75%;
  padding: 10px;
  border-left: 1px solid var(--neutral3);
}

.og-text h3,
.og-text p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 95%;
}

@media screen and (max-width: 1000px) {
  .og-container img {
    max-width: 35%;
  }
  .og-text {
    max-width: 65%;
  }
}

@media screen and (max-width: 400px) {
  .og-container {
    flex-direction: column;
  }
  .og-container img,
  .og-text {
    max-width: 100%;
  }
  .og-text {
    border-left: none;
    border-top: 1px solid var(--neutral3);
  }
}
</style>
